/* Publish by EComposer at 2026-10-08 02:39:00*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uzqvvs7sn4i"]=  window.__ectimmers["ecom-uzqvvs7sn4i"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-uzqvvs7sn4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uzqvvs7sn4i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mx30g6hzo5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mx30g6hzo5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uv50hlz84j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uv50hlz84j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sg9g0nb3lrd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sg9g0nb3lrd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1awdtkmlca4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1awdtkmlca4i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s9uwid57bq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s9uwid57bq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j637wfy4tfg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j637wfy4tfg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o7fn4uu93c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o7fn4uu93c', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}